import { client } from 'util/sdk';

export default ({ fspId, id }) =>
  client
    .fsps(fspId)
    .transactionHistoryTrackings(id)
    .query((_) => [_.fullAudit()]);
